import { render, staticRenderFns } from "./PatientDrug.vue?vue&type=template&id=76401452&scoped=true"
import script from "./PatientDrug.vue?vue&type=script&lang=js"
export * from "./PatientDrug.vue?vue&type=script&lang=js"
import style0 from "./PatientDrug.vue?vue&type=style&index=0&id=76401452&prod&scoped=true&lang=css"
import style1 from "./PatientDrug.vue?vue&type=style&index=1&id=76401452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76401452",
  null
  
)

export default component.exports